// extracted by mini-css-extract-plugin
module.exports = {"confirmRetake":"ConfirmRetake__confirmRetake__VtWGO","btnContainer":"ConfirmRetake__btnContainer__9GIrW","reportWrapper":"ConfirmRetake__reportWrapper__QC2-s"};